import { Formatter, openError, useApi } from 'gf-ui';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { Container } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router';
import Categorie from '../../libQuestionario/components/Categorie';
import { apiQuestionario } from '../api/apiQuestionario';
import BreadcrumbGF from '../components/BreadcrumbGF';
import "./QHome.scss";

const QHome = ({ homeRoute, root, title, headerComponent, bodyHeader }) => {  
  const dispatch = useDispatch()
  const navigate = useNavigate()  
  const _apiPDTA = useApi(apiQuestionario, null, root)
  const shouldInit = useRef(true)
  const [categorie, setCategorie] = useState(null)

  const getCategorie = useCallback(() => {
    _apiPDTA.fnElencoCategorie(res => {    
      setCategorie(res.categorie)      
    })
  }, [_apiPDTA])

  const getInit = useCallback(() => {
    _apiPDTA.fnInit(res => {    
      if(Formatter.getBoolean(res.flgEsitoInit)){                    
        getCategorie()       
      }else{
        openError(dispatch, res.msgEsitoInit, null, () => navigate("/"));        
      }
    })
  }, [_apiPDTA, dispatch, getCategorie, navigate])

  const onSelCategoria = (categoria) => {
    if (Formatter.isStringaVuota(categoria.ID_MA_MODELLO)) {
      navigate(`${homeRoute}/categoria/${categoria.KID}`)
    } else {
      navigate(`${homeRoute}/scheda/nuova/modello/${categoria.ID_MA_MODELLO}`)
    }
  }  

  const breadcrumbItems = useMemo(()=>{
    return [      
      { label: title }
    ]
  }, [title])

  useEffect(() => {
    if (shouldInit.current && _apiPDTA) {
      shouldInit.current = false            
      getInit()      
    }
  }, [_apiPDTA, getInit])

  return <>
    { headerComponent }
    
    <BreadcrumbGF items={breadcrumbItems} />        

    <div className='w-100 p-0 m-0 bg-light'>
      <Container className='py-4'>            
        { bodyHeader }
        <div className='w-100 text-center fw-bold text-secondary mb-2'><span>Seleziona un modello o una categoria</span></div>
        <Categorie categorie={categorie} onSelCategoria={onSelCategoria} />              
      </Container>    
    </div>
  </>
}
export default QHome;